// NGRX
import {createFeatureSelector} from '@ngrx/store';
import {EntityState, EntityAdapter, createEntityAdapter} from '@ngrx/entity';
// Actions
import {UserActions, UserActionTypes} from '../_actions/user.actions';
// CRUD
import {QueryParamsModel} from '../../_base/crud';
// Models
import {User} from '..';

// tslint:disable-next-line:no-empty-interface
export interface UsersState extends EntityState<User> {
	listLoading: boolean;
	actionsloading: boolean;
	totalCount: number;
	lastCreatedUserId: string;
	lastQuery: QueryParamsModel;
	showInitWaitingMessage: boolean;
	errors: string[];
}

export const adapter: EntityAdapter<User> = createEntityAdapter<User>();

export const initialUsersState: UsersState = adapter.getInitialState({
	listLoading: false,
	actionsloading: false,
	totalCount: 0,
	lastQuery: new QueryParamsModel({}),
	lastCreatedUserId: undefined,
	showInitWaitingMessage: true,
	errors: []
});

export function usersReducer(state = initialUsersState, action: UserActions): UsersState {
	switch (action.type) {
		case UserActionTypes.UsersPageToggleLoading:
			return {
				...state, listLoading: action.payload.isLoading, lastCreatedUserId: undefined
			};
		case UserActionTypes.UsersActionToggleLoading:
			return {
				...state, actionsloading: action.payload.isLoading
			};
		case UserActionTypes.CANCEL_SEARCH_REQUEST:
			return {
				...state, actionsloading: false
			};
		case UserActionTypes.CreateUser:
			return {
				...state, actionsloading: true
			};
		case UserActionTypes.CreateUserSuccess:
			return adapter.addOne(action.payload.user, {
				...state,
				lastCreatedUserId: action.payload.user.id,
				actionsloading: false
			});
		case UserActionTypes.CreateUserFail:
			return {
				...state,
				errors: action.payload,
				actionsloading: false
			};
		case UserActionTypes.UserUpdated:
			return adapter.updateOne(action.payload.partialUser, state);
		case UserActionTypes.BlockUser:
            return {
                ...state, actionsloading: true
            };
        case UserActionTypes.BlockUserSuccess:
            return adapter.updateOne(action.payload.userUpdated, state);

        case UserActionTypes.ActivateUser:
            return {
                ...state, actionsloading: true
            };
        case UserActionTypes.ActivateUserSuccess:
            return adapter.updateOne(action.payload.userUpdated, state);

		case UserActionTypes.UsersPageCancelled:
			return {
				...state, listLoading: false, lastQuery: new QueryParamsModel({})
			};
		case UserActionTypes.UsersPageLoaded: {
			return adapter.addMany(action.payload.users, {
				...initialUsersState,
				totalCount: action.payload.totalCount,
				lastQuery: action.payload.page,
				listLoading: false,
				showInitWaitingMessage: false
			});
		}
		default:
			return state;
	}
}

export const getUserState = createFeatureSelector<UsersState>('users');

export const {
	selectAll,
	selectEntities,
	selectIds,
	selectTotal
} = adapter.getSelectors();
